import React, { useContext } from 'react';
import { SellerRole } from '../../../gql-operations/gql-generated';

interface RolePageTabContentRoleProviderProps {
    children: React.ReactNode;
    sellerRole?: SellerRole | null;
}

const RolePageTabContentRoleContext = React.createContext<SellerRole | null | undefined>(null);

export const useCurrentTabSellerRole = () => useContext(RolePageTabContentRoleContext);

export const RolePageTabContentRoleProvider = ({ children, sellerRole }: RolePageTabContentRoleProviderProps) => (
    <RolePageTabContentRoleContext.Provider value={sellerRole}>{children}</RolePageTabContentRoleContext.Provider>
);
